import { IndicatorAlertSettingsDatasource } from "@core/data/datasources/indicator-alert-settings.datasource";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { IndicatorAlertSettings } from "@core/domain/models/indicator-alert-settings.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class IndicatorAlertSettingsRepository {
    constructor(
        @inject(IndicatorAlertSettingsDatasource)
        private readonly datasource: IndicatorAlertSettingsDatasource,
    ) {}

    fetchMy(): Promise<Either<FallbackError, IndicatorAlertSettings>> {
        return this.datasource.fetchMy();
    }

    updateMy(
        settings: IndicatorAlertSettings,
    ): Promise<Either<FallbackError, IndicatorAlertSettings>> {
        return this.datasource.updateMy(settings);
    }
}
